<template>
  <div class="teaching-score-confirm-value">
    <span v-if="hasValue"
          :class="['value', getState]">{{value}}</span>
    <span v-else
          class="empty">{{emptyText}}</span>
  </div>
</template>

<script>
import objectUtils from '../../../../../../../../../util/objectUtils'
export default {
  name: 'TeachingScoreConfirmValue',
  props: {
    scoreRule: {
      type: Object,
      required: true
    },
    value: [String, Number],
    digit: Number,
    emptyText: {
      type: String,
      default: '-'
    }
  },
  computed: {
    hasValue () {
      return objectUtils.hasValue(this.value)
    },
    getState () {
      let digit = this.digit
      if (typeof digit === 'number') {
        let passScore = this.scoreRule.passScore
        if (digit < (typeof passScore === 'number' ? passScore : 60)) {
          return 'is-fail'
        }
      }
    }
  }
}
</script>

<style lang="scss">
  .teaching-score-confirm-value {
    & > .value {
      color: #303133;
      font-weight: bold;
    }
    & > .empty {
      color: #909399;
    }
  }
</style>
